// Configuración de todas las secciones y preguntas del DS-160
// Cada pregunta puede tener allowNA: true para permitir "No Aplica"

export const DS160_SECTIONS = [
  {
    id: 1,
    name: "Información Personal",
    icon: "User",
    description: "Nombre, fecha de nacimiento, género",
    questions: [
      {
        id: "surname",
        label: "Apellido(s)",
        type: "text",
        placeholder: "GARCIA LOPEZ",
        required: true,
        allowNA: false,
        hint: "Exactamente como aparece en su pasaporte, en MAYÚSCULAS"
      },
      {
        id: "given_name",
        label: "Nombre(s)",
        type: "text",
        placeholder: "MARIA ELENA",
        required: true,
        allowNA: false,
        hint: "Exactamente como aparece en su pasaporte"
      },
      {
        id: "full_name_native",
        label: "Nombre completo en alfabeto nativo",
        type: "text",
        placeholder: "Dejar en blanco si usa alfabeto latino",
        required: false,
        allowNA: true,
        naText: "Mi idioma usa alfabeto latino"
      },
      {
        id: "has_other_names",
        label: "¿Ha usado otros nombres?",
        type: "boolean",
        hint: "Nombres de soltera, apodos, alias, etc.",
        required: true,
        allowNA: false
      },
      {
        id: "other_names",
        label: "Otros nombres usados",
        type: "text",
        placeholder: "Ej: GARCIA (nombre de soltera)",
        required: false,
        allowNA: true,
        naText: "No he usado otros nombres",
        showIf: { field: "has_other_names", value: true }
      },
      {
        id: "sex",
        label: "Sexo",
        type: "select",
        options: [
          { value: "M", label: "Masculino" },
          { value: "F", label: "Femenino" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "marital_status",
        label: "Estado Civil",
        type: "select",
        options: [
          { value: "single", label: "Soltero/a" },
          { value: "married", label: "Casado/a" },
          { value: "divorced", label: "Divorciado/a" },
          { value: "widowed", label: "Viudo/a" },
          { value: "separated", label: "Separado/a" },
          { value: "common_law", label: "Unión libre" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "birth_date",
        label: "Fecha de Nacimiento",
        type: "date",
        required: true,
        allowNA: false
      },
      {
        id: "birth_city",
        label: "Ciudad de Nacimiento",
        type: "text",
        placeholder: "Ciudad donde nació",
        required: true,
        allowNA: false
      },
      {
        id: "birth_state",
        label: "Estado/Provincia de Nacimiento",
        type: "text",
        placeholder: "Estado o provincia",
        required: false,
        allowNA: true,
        naText: "Mi país no tiene estados/provincias"
      },
      {
        id: "birth_country",
        label: "País de Nacimiento",
        type: "country",
        required: true,
        allowNA: false
      }
    ]
  },
  {
    id: 2,
    name: "Nacionalidad",
    icon: "Globe",
    description: "País de origen y ciudadanía",
    questions: [
      {
        id: "nationality",
        label: "País de Nacionalidad/Ciudadanía",
        type: "country",
        required: true,
        allowNA: false
      },
      {
        id: "has_other_nationality",
        label: "¿Tiene otra nacionalidad o ciudadanía?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "other_nationality",
        label: "Otra nacionalidad",
        type: "country",
        required: false,
        allowNA: true,
        naText: "Solo tengo una nacionalidad",
        showIf: { field: "has_other_nationality", value: true }
      },
      {
        id: "has_permanent_resident",
        label: "¿Es residente permanente de otro país?",
        type: "boolean",
        hint: "Diferente al de su nacionalidad",
        required: true,
        allowNA: false
      },
      {
        id: "permanent_resident_country",
        label: "País de residencia permanente",
        type: "country",
        required: false,
        allowNA: true,
        naText: "No soy residente permanente de otro país",
        showIf: { field: "has_permanent_resident", value: true }
      },
      {
        id: "national_id",
        label: "Número de Identificación Nacional",
        type: "text",
        placeholder: "CURP, DNI, Cédula, etc.",
        hint: "Documento de identificación de su país",
        required: true,
        allowNA: true,
        naText: "Mi país no emite número de identificación nacional"
      },
      {
        id: "us_ssn",
        label: "Número de Seguro Social de EE.UU.",
        type: "text",
        placeholder: "XXX-XX-XXXX",
        required: false,
        allowNA: true,
        naText: "No tengo número de seguro social de EE.UU."
      },
      {
        id: "us_tax_id",
        label: "Número de Identificación Fiscal de EE.UU. (ITIN)",
        type: "text",
        placeholder: "Número ITIN si aplica",
        required: false,
        allowNA: true,
        naText: "No tengo ITIN"
      }
    ]
  },
  {
    id: 3,
    name: "Dirección y Contacto",
    icon: "MapPin",
    description: "Domicilio actual y teléfonos",
    questions: [
      {
        id: "home_address",
        label: "Dirección (Calle y Número)",
        type: "text",
        placeholder: "Av. Principal #123, Col. Centro",
        required: true,
        allowNA: false
      },
      {
        id: "home_city",
        label: "Ciudad",
        type: "text",
        placeholder: "Ciudad de residencia",
        required: true,
        allowNA: false
      },
      {
        id: "home_state",
        label: "Estado/Provincia",
        type: "text",
        placeholder: "Estado o provincia",
        required: true,
        allowNA: false
      },
      {
        id: "home_postal_code",
        label: "Código Postal",
        type: "text",
        placeholder: "00000",
        required: false,
        allowNA: true,
        naText: "Mi dirección no tiene código postal"
      },
      {
        id: "home_country",
        label: "País",
        type: "country",
        required: true,
        allowNA: false
      },
      {
        id: "mailing_address_same",
        label: "¿Su dirección de correspondencia es la misma?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "mailing_address",
        label: "Dirección de Correspondencia",
        type: "textarea",
        placeholder: "Dirección completa de correspondencia",
        required: false,
        allowNA: true,
        naText: "Mi dirección de correspondencia es la misma",
        showIf: { field: "mailing_address_same", value: false }
      },
      {
        id: "phone_primary",
        label: "Teléfono Principal",
        type: "tel",
        placeholder: "+52 55 1234 5678",
        required: true,
        allowNA: false
      },
      {
        id: "phone_secondary",
        label: "Teléfono Secundario",
        type: "tel",
        placeholder: "+52 55 8765 4321",
        required: false,
        allowNA: true,
        naText: "No tengo teléfono secundario"
      },
      {
        id: "phone_work",
        label: "Teléfono de Trabajo",
        type: "tel",
        placeholder: "+52 55 1111 2222",
        required: false,
        allowNA: true,
        naText: "No tengo teléfono de trabajo"
      },
      {
        id: "email",
        label: "Correo Electrónico",
        type: "email",
        placeholder: "correo@ejemplo.com",
        required: true,
        allowNA: false
      }
    ]
  },
  {
    id: 4,
    name: "Pasaporte",
    icon: "CreditCard",
    description: "Datos del documento de viaje",
    questions: [
      {
        id: "passport_type",
        label: "Tipo de Pasaporte",
        type: "select",
        options: [
          { value: "regular", label: "Regular/Ordinario" },
          { value: "official", label: "Oficial" },
          { value: "diplomatic", label: "Diplomático" },
          { value: "other", label: "Otro" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "passport_number",
        label: "Número de Pasaporte",
        type: "text",
        placeholder: "G12345678",
        required: true,
        allowNA: false,
        hint: "Exactamente como aparece en el pasaporte"
      },
      {
        id: "passport_book_number",
        label: "Número de Libro de Pasaporte",
        type: "text",
        placeholder: "Solo si aplica",
        required: false,
        allowNA: true,
        naText: "Mi pasaporte no tiene número de libro"
      },
      {
        id: "passport_country",
        label: "País que Emitió el Pasaporte",
        type: "country",
        required: true,
        allowNA: false
      },
      {
        id: "passport_city_issued",
        label: "Ciudad de Emisión",
        type: "text",
        placeholder: "Ciudad donde fue emitido",
        required: true,
        allowNA: false
      },
      {
        id: "passport_state_issued",
        label: "Estado/Provincia de Emisión",
        type: "text",
        required: false,
        allowNA: true,
        naText: "No aplica estado/provincia"
      },
      {
        id: "passport_issue_date",
        label: "Fecha de Emisión",
        type: "date",
        required: true,
        allowNA: false
      },
      {
        id: "passport_expiry_date",
        label: "Fecha de Vencimiento",
        type: "date",
        required: true,
        allowNA: false,
        hint: "Debe tener al menos 6 meses de vigencia"
      },
      {
        id: "has_lost_passport",
        label: "¿Ha perdido o le han robado un pasaporte?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "lost_passport_details",
        label: "Detalles del pasaporte perdido/robado",
        type: "textarea",
        placeholder: "Número, año y circunstancias",
        required: false,
        allowNA: true,
        naText: "Nunca he perdido un pasaporte",
        showIf: { field: "has_lost_passport", value: true }
      }
    ]
  },
  {
    id: 5,
    name: "Viaje",
    icon: "Plane",
    description: "Propósito y fechas del viaje",
    questions: [
      {
        id: "travel_purpose",
        label: "Propósito Principal del Viaje",
        type: "select",
        options: [
          { value: "tourism", label: "Turismo/Vacaciones" },
          { value: "business", label: "Negocios" },
          { value: "medical", label: "Tratamiento Médico" },
          { value: "education", label: "Estudios/Conferencia" },
          { value: "family", label: "Visita Familiar" },
          { value: "transit", label: "Tránsito" },
          { value: "other", label: "Otro" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "travel_specific_plans",
        label: "¿Tiene planes específicos de viaje?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "arrival_date",
        label: "Fecha Estimada de Llegada",
        type: "date",
        required: false,
        allowNA: true,
        naText: "Aún no tengo fecha definida",
        showIf: { field: "travel_specific_plans", value: true }
      },
      {
        id: "departure_date",
        label: "Fecha Estimada de Salida",
        type: "date",
        required: false,
        allowNA: true,
        naText: "Aún no tengo fecha de regreso definida",
        showIf: { field: "travel_specific_plans", value: true }
      },
      {
        id: "arrival_city",
        label: "Ciudad de Llegada en EE.UU.",
        type: "text",
        placeholder: "Ej: Miami, Los Angeles, New York",
        required: false,
        allowNA: true,
        naText: "Aún no defino ciudad de llegada"
      },
      {
        id: "stay_address",
        label: "Dirección donde se hospedará",
        type: "textarea",
        placeholder: "Hotel, casa de familiar, etc.",
        required: false,
        allowNA: true,
        naText: "Aún no defino hospedaje"
      },
      {
        id: "who_pays_trip",
        label: "¿Quién pagará su viaje?",
        type: "select",
        options: [
          { value: "self", label: "Yo mismo" },
          { value: "employer", label: "Mi empleador" },
          { value: "family_us", label: "Familiar en EE.UU." },
          { value: "family_other", label: "Familiar en mi país" },
          { value: "company_us", label: "Empresa en EE.UU." },
          { value: "other", label: "Otro" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "payer_details",
        label: "Datos de quien paga (si no es usted)",
        type: "textarea",
        placeholder: "Nombre, relación, dirección",
        required: false,
        allowNA: true,
        naText: "Yo pago mi propio viaje",
        showIf: { field: "who_pays_trip", notValue: "self" }
      }
    ]
  },
  {
    id: 6,
    name: "Viajes Previos a EE.UU.",
    icon: "History",
    description: "Historial de viajes anteriores",
    questions: [
      {
        id: "has_previous_us_travel",
        label: "¿Ha viajado a Estados Unidos antes?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "previous_travel_dates",
        label: "Fechas de viajes anteriores (últimos 5 años)",
        type: "textarea",
        placeholder: "Ej: Enero 2022 (2 semanas), Julio 2023 (1 mes)",
        required: false,
        allowNA: true,
        naText: "Nunca he viajado a EE.UU.",
        showIf: { field: "has_previous_us_travel", value: true }
      },
      {
        id: "us_drivers_license",
        label: "¿Ha tenido licencia de conducir de EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "us_drivers_license_details",
        label: "Detalles de la licencia",
        type: "text",
        placeholder: "Estado y número (si lo recuerda)",
        required: false,
        allowNA: true,
        naText: "Nunca he tenido licencia de EE.UU.",
        showIf: { field: "us_drivers_license", value: true }
      },
      {
        id: "has_previous_visa",
        label: "¿Ha tenido visa de EE.UU. antes?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "previous_visa_number",
        label: "Número de visa anterior",
        type: "text",
        placeholder: "Si lo tiene disponible",
        required: false,
        allowNA: true,
        naText: "No recuerdo/no tengo el número",
        showIf: { field: "has_previous_visa", value: true }
      },
      {
        id: "previous_visa_issue_date",
        label: "Fecha de emisión de visa anterior",
        type: "date",
        required: false,
        allowNA: true,
        naText: "No recuerdo la fecha exacta",
        showIf: { field: "has_previous_visa", value: true }
      },
      {
        id: "visa_same_type",
        label: "¿Solicita el mismo tipo de visa?",
        type: "boolean",
        required: false,
        allowNA: true,
        naText: "Es mi primera visa",
        showIf: { field: "has_previous_visa", value: true }
      },
      {
        id: "visa_same_country",
        label: "¿Solicita en el mismo país que antes?",
        type: "boolean",
        required: false,
        allowNA: true,
        naText: "Es mi primera solicitud",
        showIf: { field: "has_previous_visa", value: true }
      },
      {
        id: "visa_was_refused",
        label: "¿Le han negado una visa de EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: false,
        hint: "Sea honesto, mentir es peor que una negación previa"
      },
      {
        id: "visa_refusal_details",
        label: "Detalles de la negación",
        type: "textarea",
        placeholder: "Fecha, tipo de visa, razón (si la conoce)",
        required: false,
        allowNA: true,
        naText: "Nunca me han negado visa",
        showIf: { field: "visa_was_refused", value: true }
      },
      {
        id: "visa_was_cancelled",
        label: "¿Le han cancelado/revocado una visa?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "visa_cancellation_details",
        label: "Detalles de la cancelación",
        type: "textarea",
        placeholder: "Fecha y circunstancias",
        required: false,
        allowNA: true,
        naText: "Nunca me han cancelado visa",
        showIf: { field: "visa_was_cancelled", value: true }
      }
    ]
  },
  {
    id: 7,
    name: "Contacto en EE.UU.",
    icon: "Contact",
    description: "Persona o lugar de contacto",
    questions: [
      {
        id: "us_contact_name",
        label: "Nombre de la persona u organización de contacto",
        type: "text",
        placeholder: "Ej: John Smith / Holiday Inn Miami",
        required: true,
        allowNA: true,
        naText: "No conozco a nadie en EE.UU.",
        hint: "Puede ser familiar, amigo, hotel o empresa"
      },
      {
        id: "us_contact_organization",
        label: "Nombre de la organización (si aplica)",
        type: "text",
        placeholder: "Empresa, hotel, universidad, etc.",
        required: false,
        allowNA: true,
        naText: "No es una organización"
      },
      {
        id: "us_contact_relationship",
        label: "Relación con el contacto",
        type: "select",
        options: [
          { value: "relative", label: "Familiar" },
          { value: "friend", label: "Amigo" },
          { value: "business", label: "Contacto de negocios" },
          { value: "hotel", label: "Hotel" },
          { value: "company", label: "Empresa" },
          { value: "school", label: "Escuela/Universidad" },
          { value: "other", label: "Otro" }
        ],
        required: true,
        allowNA: true,
        naText: "No tengo contacto en EE.UU."
      },
      {
        id: "us_contact_address",
        label: "Dirección del contacto",
        type: "text",
        placeholder: "123 Main Street",
        required: true,
        allowNA: true,
        naText: "No tengo la dirección exacta"
      },
      {
        id: "us_contact_city",
        label: "Ciudad",
        type: "text",
        placeholder: "Miami",
        required: true,
        allowNA: true,
        naText: "No sé la ciudad exacta"
      },
      {
        id: "us_contact_state",
        label: "Estado",
        type: "us_state",
        required: true,
        allowNA: true,
        naText: "No sé el estado"
      },
      {
        id: "us_contact_zip",
        label: "Código Postal",
        type: "text",
        placeholder: "33101",
        required: false,
        allowNA: true,
        naText: "No conozco el código postal"
      },
      {
        id: "us_contact_phone",
        label: "Teléfono del contacto",
        type: "tel",
        placeholder: "+1 (305) 555-1234",
        required: false,
        allowNA: true,
        naText: "No tengo su número de teléfono"
      },
      {
        id: "us_contact_email",
        label: "Email del contacto",
        type: "email",
        placeholder: "contacto@email.com",
        required: false,
        allowNA: true,
        naText: "No tengo su email"
      }
    ]
  },
  {
    id: 8,
    name: "Familia",
    icon: "Users",
    description: "Información de padres y cónyuge",
    questions: [
      {
        id: "father_surname",
        label: "Apellido(s) del Padre",
        type: "text",
        required: true,
        allowNA: true,
        naText: "Desconozco información de mi padre"
      },
      {
        id: "father_given_name",
        label: "Nombre(s) del Padre",
        type: "text",
        required: true,
        allowNA: true,
        naText: "Desconozco información de mi padre"
      },
      {
        id: "father_birth_date",
        label: "Fecha de Nacimiento del Padre",
        type: "date",
        required: false,
        allowNA: true,
        naText: "No conozco la fecha exacta"
      },
      {
        id: "father_in_us",
        label: "¿Su padre está en EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: true,
        naText: "Desconozco su ubicación"
      },
      {
        id: "father_us_status",
        label: "Estatus migratorio del padre en EE.UU.",
        type: "select",
        options: [
          { value: "citizen", label: "Ciudadano" },
          { value: "resident", label: "Residente Permanente" },
          { value: "nonimmigrant", label: "Visa de No Inmigrante" },
          { value: "other", label: "Otro" }
        ],
        required: false,
        allowNA: true,
        naText: "Mi padre no está en EE.UU.",
        showIf: { field: "father_in_us", value: true }
      },
      {
        id: "mother_surname",
        label: "Apellido(s) de la Madre",
        type: "text",
        required: true,
        allowNA: true,
        naText: "Desconozco información de mi madre"
      },
      {
        id: "mother_given_name",
        label: "Nombre(s) de la Madre",
        type: "text",
        required: true,
        allowNA: true,
        naText: "Desconozco información de mi madre"
      },
      {
        id: "mother_birth_date",
        label: "Fecha de Nacimiento de la Madre",
        type: "date",
        required: false,
        allowNA: true,
        naText: "No conozco la fecha exacta"
      },
      {
        id: "mother_in_us",
        label: "¿Su madre está en EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: true,
        naText: "Desconozco su ubicación"
      },
      {
        id: "mother_us_status",
        label: "Estatus migratorio de la madre en EE.UU.",
        type: "select",
        options: [
          { value: "citizen", label: "Ciudadano" },
          { value: "resident", label: "Residente Permanente" },
          { value: "nonimmigrant", label: "Visa de No Inmigrante" },
          { value: "other", label: "Otro" }
        ],
        required: false,
        allowNA: true,
        naText: "Mi madre no está en EE.UU.",
        showIf: { field: "mother_in_us", value: true }
      },
      {
        id: "has_relatives_in_us",
        label: "¿Tiene otros familiares en EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "relatives_in_us_details",
        label: "Detalles de familiares en EE.UU.",
        type: "textarea",
        placeholder: "Nombre, relación y estatus migratorio",
        required: false,
        allowNA: true,
        naText: "No tengo familiares en EE.UU.",
        showIf: { field: "has_relatives_in_us", value: true }
      },
      {
        id: "spouse_surname",
        label: "Apellido(s) del Cónyuge",
        type: "text",
        required: false,
        allowNA: true,
        naText: "No estoy casado/a",
        showIf: { field: "marital_status", values: ["married", "common_law", "separated"] }
      },
      {
        id: "spouse_given_name",
        label: "Nombre(s) del Cónyuge",
        type: "text",
        required: false,
        allowNA: true,
        naText: "No estoy casado/a",
        showIf: { field: "marital_status", values: ["married", "common_law", "separated"] }
      },
      {
        id: "spouse_birth_date",
        label: "Fecha de Nacimiento del Cónyuge",
        type: "date",
        required: false,
        allowNA: true,
        naText: "No conozco la fecha exacta",
        showIf: { field: "marital_status", values: ["married", "common_law", "separated"] }
      },
      {
        id: "spouse_nationality",
        label: "Nacionalidad del Cónyuge",
        type: "country",
        required: false,
        allowNA: true,
        naText: "No estoy casado/a",
        showIf: { field: "marital_status", values: ["married", "common_law", "separated"] }
      }
    ]
  },
  {
    id: 9,
    name: "Trabajo/Empleo",
    icon: "Briefcase",
    description: "Empleo actual e ingresos",
    questions: [
      {
        id: "occupation",
        label: "Ocupación Actual",
        type: "select",
        options: [
          { value: "employed", label: "Empleado" },
          { value: "self_employed", label: "Trabajador Independiente" },
          { value: "business_owner", label: "Dueño de Negocio" },
          { value: "student", label: "Estudiante" },
          { value: "retired", label: "Jubilado/Pensionado" },
          { value: "homemaker", label: "Ama de Casa" },
          { value: "unemployed", label: "Desempleado" },
          { value: "other", label: "Otro" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "employer_name",
        label: "Nombre del Empleador/Empresa",
        type: "text",
        placeholder: "Nombre de la empresa donde trabaja",
        required: false,
        allowNA: true,
        naText: "No trabajo para una empresa",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "employer_address",
        label: "Dirección del Trabajo",
        type: "text",
        placeholder: "Dirección completa",
        required: false,
        allowNA: true,
        naText: "Trabajo desde casa / No aplica",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "employer_city",
        label: "Ciudad del Trabajo",
        type: "text",
        required: false,
        allowNA: true,
        naText: "No aplica",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "employer_phone",
        label: "Teléfono del Trabajo",
        type: "tel",
        required: false,
        allowNA: true,
        naText: "No tengo teléfono de trabajo",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "job_title",
        label: "Puesto/Cargo",
        type: "text",
        placeholder: "Ej: Gerente, Contador, Ingeniero",
        required: false,
        allowNA: true,
        naText: "No aplica",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "job_start_date",
        label: "Fecha de Inicio en el Trabajo",
        type: "date",
        required: false,
        allowNA: true,
        naText: "No recuerdo la fecha exacta",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "monthly_salary",
        label: "Salario Mensual (en moneda local)",
        type: "text",
        placeholder: "Ej: $25,000 MXN",
        required: false,
        allowNA: true,
        naText: "Prefiero no proporcionar esta información",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "job_description",
        label: "Descripción del Trabajo",
        type: "textarea",
        placeholder: "Describa brevemente sus funciones",
        required: false,
        allowNA: true,
        naText: "No aplica",
        showIf: { field: "occupation", values: ["employed", "self_employed", "business_owner"] }
      },
      {
        id: "previous_employer",
        label: "¿Ha tenido otros empleos en los últimos 5 años?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "previous_employment_details",
        label: "Empleos anteriores (últimos 5 años)",
        type: "textarea",
        placeholder: "Empresa, puesto, fechas",
        required: false,
        allowNA: true,
        naText: "No he tenido otros empleos",
        showIf: { field: "previous_employer", value: true }
      }
    ]
  },
  {
    id: 10,
    name: "Educación",
    icon: "GraduationCap",
    description: "Formación académica",
    questions: [
      {
        id: "education_level",
        label: "Nivel Máximo de Estudios",
        type: "select",
        options: [
          { value: "none", label: "Sin educación formal" },
          { value: "primary", label: "Primaria" },
          { value: "secondary", label: "Secundaria" },
          { value: "high_school", label: "Preparatoria/Bachillerato" },
          { value: "technical", label: "Técnico/Vocacional" },
          { value: "bachelor", label: "Licenciatura" },
          { value: "master", label: "Maestría" },
          { value: "doctorate", label: "Doctorado" }
        ],
        required: true,
        allowNA: false
      },
      {
        id: "school_name",
        label: "Nombre de la Institución Educativa",
        type: "text",
        placeholder: "Universidad, colegio, etc.",
        required: false,
        allowNA: true,
        naText: "No aplica / Prefiero no proporcionar"
      },
      {
        id: "school_address",
        label: "Dirección de la Institución",
        type: "text",
        placeholder: "Ciudad y país",
        required: false,
        allowNA: true,
        naText: "No recuerdo la dirección"
      },
      {
        id: "course_of_study",
        label: "Carrera/Área de Estudio",
        type: "text",
        placeholder: "Ej: Administración de Empresas",
        required: false,
        allowNA: true,
        naText: "No aplica"
      },
      {
        id: "education_start_date",
        label: "Fecha de Inicio de Estudios",
        type: "date",
        required: false,
        allowNA: true,
        naText: "No recuerdo la fecha"
      },
      {
        id: "education_end_date",
        label: "Fecha de Finalización",
        type: "date",
        required: false,
        allowNA: true,
        naText: "Aún estudio / No recuerdo"
      }
    ]
  },
  {
    id: 11,
    name: "Seguridad",
    icon: "Shield",
    description: "Preguntas de elegibilidad",
    hint: "Responda con honestidad. Estas preguntas son obligatorias y verificables.",
    questions: [
      {
        id: "security_disease",
        label: "¿Tiene alguna enfermedad contagiosa de importancia para la salud pública?",
        type: "boolean",
        required: true,
        allowNA: false,
        hint: "Tuberculosis activa, etc."
      },
      {
        id: "security_disorder",
        label: "¿Tiene algún trastorno físico o mental que pueda representar una amenaza?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_drug_addict",
        label: "¿Es o ha sido adicto a drogas?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_arrested",
        label: "¿Ha sido arrestado o condenado por algún delito?",
        type: "boolean",
        required: true,
        allowNA: false,
        hint: "Incluye delitos menores y de tránsito graves"
      },
      {
        id: "security_arrest_details",
        label: "Detalles del arresto/condena",
        type: "textarea",
        placeholder: "Fecha, lugar, delito, resultado",
        required: false,
        allowNA: true,
        naText: "Nunca he sido arrestado",
        showIf: { field: "security_arrested", value: true }
      },
      {
        id: "security_controlled_substances",
        label: "¿Ha violado leyes de sustancias controladas?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_prostitution",
        label: "¿Ha participado en prostitución o tráfico de personas?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_money_laundering",
        label: "¿Ha participado en lavado de dinero?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_trafficking",
        label: "¿Ha participado en tráfico de personas?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_terrorist",
        label: "¿Ha participado en actividades terroristas?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_genocide",
        label: "¿Ha participado en genocidio, tortura o violaciones de derechos humanos?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_child_custody",
        label: "¿Ha retenido la custodia de un menor ciudadano de EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_voting",
        label: "¿Ha votado ilegalmente en EE.UU.?",
        type: "boolean",
        required: true,
        allowNA: false
      },
      {
        id: "security_tax_evasion",
        label: "¿Ha renunciado a la ciudadanía estadounidense para evadir impuestos?",
        type: "boolean",
        required: true,
        allowNA: false
      }
    ]
  },
  {
    id: 12,
    name: "Confirmación",
    icon: "CheckCircle2",
    description: "Revisar y confirmar",
    questions: [
      {
        id: "additional_info",
        label: "Información Adicional",
        type: "textarea",
        placeholder: "Cualquier información adicional que desee proporcionar",
        required: false,
        allowNA: true,
        naText: "No tengo información adicional que agregar"
      },
      {
        id: "final_confirmation",
        label: "Confirmo que toda la información es verdadera y correcta",
        type: "boolean",
        required: true,
        allowNA: false,
        hint: "Proporcionar información falsa puede resultar en negación permanente de visa"
      }
    ]
  }
];

// Países disponibles
export const COUNTRIES = [
  "México", "Colombia", "Argentina", "Perú", "Chile", "Ecuador", "Venezuela", "Guatemala",
  "Honduras", "El Salvador", "Nicaragua", "Costa Rica", "Panamá", "República Dominicana",
  "Puerto Rico", "Cuba", "Brasil", "España", "Estados Unidos", "Canadá", "Otro"
];

// Estados de EE.UU.
export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
  "Wisconsin", "Wyoming", "District of Columbia"
];

// Helper: Obtener total de preguntas de una sección (considerando showIf)
export const getSectionQuestionCount = (section, formData = {}) => {
  return section.questions.filter(q => {
    if (!q.showIf) return true;
    const { field, value, values, notValue } = q.showIf;
    const fieldValue = formData[field];
    if (value !== undefined) return fieldValue === value;
    if (values !== undefined) return values.includes(fieldValue);
    if (notValue !== undefined) return fieldValue !== notValue;
    return true;
  }).length;
};

// Helper: Calcular progreso de una sección
export const calculateSectionProgress = (section, formData = {}, naFields = {}) => {
  const visibleQuestions = section.questions.filter(q => {
    if (!q.showIf) return true;
    const { field, value, values, notValue } = q.showIf;
    const fieldValue = formData[field];
    if (value !== undefined) return fieldValue === value;
    if (values !== undefined) return values.includes(fieldValue);
    if (notValue !== undefined) return fieldValue !== notValue;
    return true;
  });
  
  const answered = visibleQuestions.filter(q => {
    // Si está marcado como N/A, cuenta como respondido
    if (naFields[q.id]) return true;
    // Si tiene valor, cuenta como respondido
    const value = formData[q.id];
    if (typeof value === 'boolean') return true;
    if (typeof value === 'string') return value.trim() !== '';
    return value !== undefined && value !== null;
  }).length;
  
  return {
    answered,
    total: visibleQuestions.length,
    percentage: visibleQuestions.length > 0 ? Math.round((answered / visibleQuestions.length) * 100) : 0,
    isComplete: answered === visibleQuestions.length && visibleQuestions.length > 0
  };
};
